<template>
  <div id="app">
    <!-- 页面内容区 -->
    <div class="page-content">
      <!-- 图片展示 -->
      <div class="top">
        <div class="time">
       <span class="date">{{ formattedDate }}</span>
     <span class="shijian">{{ currentTime }}</span>
          <span>{{ currentDay }}</span>
        </div>
              <!-- 顶部导航菜单 -->
      <nav class="main-nav">
        <div 
          v-for="item in navItems" 
          :key="item.name"
          class="nav-item"
          :class="{ active: currentView === item.component }"
          @click="switchView(item.component)"
        >
         <img :src="getIconPath(item.icon)" alt="Icon" class="nav-icon">
          {{ item.name }}
        </div>
      </nav>
      </div>



      <!-- 内容展示 -->
      <div class="content-area">
        <CityShow v-if="currentView === 'CityShow'" />
        <WaterPage v-if="currentView === 'WaterPage'" />
        <TravelPage v-if="currentView === 'TravelPage'" />
        <ParkingPage v-if="currentView === 'ParkingPage'" />
        <FirePage v-if="currentView === 'FirePage'" />
        <!-- 其他页面组件... -->
      </div>
    </div>
  </div>
</template>

<script>
import CityShow from './components/CityShow.vue'
import WaterPage from './components/water.vue'
import TravelPage from './components/Travel.vue'
import ParkingPage from './components/ParkingPage.vue'
import FirePage from './components/FirePage.vue'

export default {
  components: { CityShow, WaterPage, TravelPage,ParkingPage,FirePage },
  data() {
    return {
      currentView: 'CityShow', // 默认显示总览页
      currentTime: '',
      formattedDate: "",
      currentDay: "",
      navItems: [
        { name: '总览', component: 'CityShow' , icon: 'total' },
        { name: '水务', component: 'WaterPage' , icon: 'water'},
        { name: '停车', component: 'ParkingPage' , icon: 'parking'},
        { name: '燃气', component: 'FirePage' , icon: 'fire'},
        { name: '旅游', component: 'TravelPage', icon: 'travel' }
      ]
    }
  },
   mounted() {
    this.getCurrentDate();
  },
  created() {
    // 在组件创建时启动定时器
    this.updateTime();
  },
  methods: {
    getIconPath(iconName) {
    try {
      return require(`./images/${iconName}.png`)
    } catch (error) {
      console.error('Icon not found:', iconName)
      return '' // 返回占位符或默认图标
    }
  },
    switchView(view) {
      this.currentView = view;
    },
      updateTime() {
      // 使用 setInterval 每秒更新一次时间
      setInterval(() => {
        const now = new Date();
        this.currentTime = now.toLocaleTimeString();
      }, 1000);
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const daysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];
      const dayOfWeek = "星期" + daysOfWeek[date.getDay()];
      this.formattedDate = `${year}-${month}-${day}`;
      this.currentDay = dayOfWeek;
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 16px;
}
  .top {
    position: relative;
    height: 255px;
    background-image: url('./images/bg1.png');
    background-size: 100% 100%;
    .time {
      position: absolute;
      font-size: 8px;
      width: 176px;
      height: 20px;
      /* bottom: 100px; */
      /* left: 100px; */
      top:2px;
      right: 1px;
      display: flex;
      line-height: 20px;
      font-weight: 400;
     justify-content: center;

      span {
        color: #76797b;
      }
       .date{
    margin-right: 5px;
   }
   .shijian{
    margin-right: 5px;
   }
    }
.main-nav {
  display: flex;
  justify-content: center;
  /* background: #b0d957; */
    /* 从上到下的线性渐变 */
  /* background: linear-gradient( #d2f38b,#95b848); */
  /* background: linear-gradient(to right, #b0d957, #558d40);
  padding: 0 20px; */
}

.nav-item {
  padding:  10px;
  /* color: #5b6fd6; */
   color: #696969;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  font-size: 15px;
  margin-top: 55%;
  margin-left: 2.5%;
}

.nav-item:hover {
  color: #696969;
}

.nav-item.active {
  color: #696969;
  font-size: 15px;
  /* font-weight: bold; */
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  right: 20%;
  height: 3px;
  background: #4eba96;
}
.nav-icon {
  width: 36px; 
  height:36px;
  margin-right: 3px; 
  vertical-align: middle; 
}
  }
.page-content {
  max-width: 1200px;
  margin: 0 auto;

}

.banner-image {
  width: 100%;
  margin-bottom: 20px;
}

.banner-image img {
  width: 100%;
  height: auto;
}


</style>